import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import ButtonCustom from "components/Atoms/Button";
import { useState } from "react";

export function ModalChooseCoin({
  open,
  handleClose,
  onChange,
  defaultValue,
  options,
}) {
  const [selected, setSelected] = useState(defaultValue);

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="sm"
      PaperProps={{
        style: {
          width: "100%",
          padding: 1,
          backgroundColor: "rgb(67 67 67)",
          color: "white",
          borderRadius: '20px'
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle>
        <p
          style={{
            fontWeight: "900",
            fontSize: "24px",
            margin: "0",
            textAlign: "center",
          }}
        >
          Choose coin
        </p>
      </DialogTitle>
      <form onSubmit={() => { }}>
        <DialogContent>
          <p style={{ margin: '0 0 3px 0' }} >Coin</p>
          <Autocomplete
            fullWidth
            options={options}
            getOptionLabel={(option) => { return (option.symbol + ' ' + `(${option?.network?.key})`) }}
            sx={{ color: "#2acbfe" }}
            defaultValue={defaultValue}
            renderOption={(props, option) => (
              <div {...props}>
                <div style={{ position: 'relative' }}>
                  <img
                    height="30"
                    width="30"
                    style={{ borderRadius: '50%' }}
                    alt={option?.name}
                    src={option?.image}
                  />
                  <img
                    height="15"
                    width="15"
                    alt={option?.name}
                    src={option?.network?.image}
                    style={{ position: 'absolute', bottom: 0, right: 0, borderRadius: '50%' }}
                  />
                </div>

                <span style={{ marginLeft: "10px", fontWeight: 'bold' }}>
                  {option?.symbol}
                  <span style={{ marginLeft: "5px", fontWeight: 'normal' }}>
                    ({option?.network?.key})
                  </span>

                </span>
              </div>
            )}

            renderInput={(params) => (
              <>
                <TextField
                  {...params}
                  label=""
                  sx={{
                    color: "white",
                    background: "white",
                    borderRadius: "7px",
                  }}
                  InputLabelProps={{
                    style: { color: "#2acbfe" },
                  }}
                />
              </>

            )}
            onChange={(_, option) => {
              setSelected(option);
            }}
          />
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <ButtonCustom
              onClick={() => {
                onChange(selected);
                handleClose();
              }}
              disabled={!selected}
            >
              SELECT
            </ButtonCustom>
          </div>
        </DialogContent>
      </form>
    </Dialog>
  );
}
